import { Divider, Text, TextProps } from '@mantine/core'
import React from 'react'

const TextDashboardSectionTitle = (prop: TextProps) => {
  return (
    <div className="pagebreak" {...prop}>
      <Divider my="md" />
      <Text color="gray" size="xl" mb="sm" fw="bold">
        {prop.children}
      </Text>
    </div>
  )
}

export default TextDashboardSectionTitle
